import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";

# راهنمای داشبورد کنترل کیفیت (Quality Home)

این صفحه نمای کلی از وضعیت کنترل کیفیت در سیستم را ارائه می‌دهد.

## امکانات اصلی
- مشاهده خلاصه وضعیت کیفیت
- دسترسی سریع به خانواده‌های بررسی کیفی
- دسترسی سریع به سوابق بازرسی‌ها
- گزارشات و آمارهای لحظه‌ای

export default function Page({ children }) {
  return <Layout>{children}</Layout>;
}
